<template>
    <span>
        <el-form-item :label="label" >       
            <el-image 
                class="style-img"
                :src="imgUrl" 
                :preview-src-list="srcList">
            </el-image>
            <!-- <el-upload
                class="avatar-uploader"
                action="/extwarapi/api/file/fileUpload"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                >
                <img v-if="imgUrl" :src="imgUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-image-viewer
                v-if="showViewer"
                :on-close="closeViewer"
                :url-list="[imgUrl]">
            </el-image-viewer>
            <el-button @click="onPreview">查看</el-button> -->
        </el-form-item>         
    </span>
</template>
<script>
// import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default { 
    // components:{ElImageViewer},
    data(){
        return{
            srcList:[this.changUrl(this.objImgUrl) ],          
            imgUrl:this.changUrl(this.objImgUrl),
            showViewer: false
        }
    },
    props:{   
        objImgUrl: {
            type: String
        },  
        label:{
            type:String,
        }
    },
    watch: { 
        objImgUrl(newVal,oldVal){
            this.imgUrl = this.changUrl(newVal);
            this.srcList=[this.imgUrl];
        }
  
    },
    methods:{
        changUrl:function(url){
            let turl = url;
            if(url==null || url==''){
                turl = require('../../assets/kongbai.png')
            }
            return turl;
        },
        handleAvatarSuccess(res, file){
            console.log('上传',res)
            this.imgUrl = this.changUrl(res.result)
            this.srcList = [this.changUrl(res.result)]
        },
        onPreview(){
            console.log('this',this.imgUrl)
            this.showViewer = true
        },
        closeViewer(){
            this.showViewer = false
        }
    }

}
</script>
<style lang="scss"  >
    .style-img{
        width: 220px;
        height: 120px
    }
</style>